import {createApp} from 'vue'
import axios from './axios';
import router from './router/';
import ElementPlus from 'element-plus'
import request from './axios'
import createIcon from './icon';
import 'element-plus/theme-chalk/dark/css-vars.css'
import 'element-plus/dist/index.css'
import ZkElPlus from '@zk-ui/el-plus'
import '@zk-ui/el-plus/lib/style.css';
import DataVVue3 from '@kjgl77/datav-vue3'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {toIconLine} from './utils/elements'
import {website} from '@/config.js'
import draggable from '@/page/components/draggable.vue'
import {loadScript} from '@/utils/utils'
import error from './error';
import App from './App.vue'
import './styles/common.scss'
import '@/utils/es6'
import hljs from 'highlight.js' //导入代码高亮文件
import 'highlight.js/styles/atom-one-dark.css'  //导入代码高亮样
import GlobalComponents from "components/globalComponents";
import 'virtual:svg-icons-register';
import demo from '../lib-pkg/lib'
import elCountUp from "./acomponets/count-up/index.vue";
import {setPx, deepClone, validData} from './acomponets/utils/util';
import contextmenu from './option/common/contextmenu';
import {validatenull} from './acomponets/utils/validate';

const app = createApp(App)
window.axios = axios;
window.$loadScript = loadScript;
document.title = website.title
// createIcon(app);
app.directive('highlight', function (el) {
  let highlight = el.querySelectorAll('pre code');
  highlight.forEach((block) => {
    hljs.highlightBlock(block)
  })
});
app.directive('contextmenu', contextmenu);
app.config.globalProperties.$component = componentFunc
// app.config.globalProperties.$component = app.component
app.config.globalProperties.$website = website;
app.config.globalProperties.setPx = setPx;
app.config.globalProperties.deepClone = deepClone;
app.config.globalProperties.validData = validData;
app.config.globalProperties.validatenull = validatenull;
app.use(DataVVue3)
app.use(error);
app.use(router)
app.use(GlobalComponents)
for (let i in ElementPlusIconsVue) {
  let name = toIconLine(i);
  app.component(name, (ElementPlusIconsVue)[i])
}
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(ElementPlus, {
  locale: zhCn
})
app.use(ZkElPlus, {request})
window.CopyData = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};
app.mount('#app')
console.log('app._context.components', app._context)

// 避免组件重复注册
function componentFunc(name, component) {
  if (app.component(name)) return
  app.component(name, component)
}